<template>
  <input type="text" class="form-control" id="search-place" :value="getPlaceName" />
</template>

<script>
export default {
  props: [
    'placeName'
  ],
  data() {
    return {
      autocomplete: {}
    }
  },
  computed: {
    getPlaceName() {
      return this.placeName
    }
  },
  mounted() {
    const locationInput = document.getElementById('search-place');
    const options = {
      types: ['(cities)'],
      // componentRestrictions: {country: 'fr'}
    }

    this.autocomplete = new google.maps.places.Autocomplete(locationInput, options)
    this.autocomplete.addListener('place_changed', this.getPlaces)
  },
  methods: {
    getPlaces() {
      // console.log(this.locationAutocomplete.getPlace())
      const placeDetail = this.autocomplete.getPlace()
      this.$emit('placeChanged', placeDetail)
    }
  }
}
</script>